import {FormControl, FormGroup, Validators} from '@angular/forms';
import {AdvertisingPlatformInfoForm} from './advertising-platform-info-form';

export class MicrosoftAdsInfoForm extends AdvertisingPlatformInfoForm {

  constructor() {
    super();
    this.formGroup = new FormGroup({
      currencyId: new FormControl('', Validators.required),
      accountId: new FormControl('', Validators.required),
      customerId: new FormControl('', Validators.required),
    });
  }

  static override getPlatformName(): string {
    return 'microsoft-ads';
  }
}
